<template>
  <div
    :class="{large:large}"
    class="pwd-input"
  >
    <input
      v-model="payPwd"
      :disabled="disabled"
      type="number"
    >
    <div
      v-for="i in len"
      :key="i"
      :class="{active: i - 1 === payPwd.length}"
    >
      {{ payPwd[i-1] }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    value: String,
    large: Boolean,
    len: Number,
  },
  data () {
    return {
      payPwd: ''
    }
  },
  watch: {
    value () {
      this.payPwd = this.value
    },
    payPwd (newValue) {
      this.payPwd = this.payPwd.replace(/[^0-9]/g, '').substring(0, this.len)
      this.$emit('input', this.payPwd)
    //   if (!this.isLack && !this.loading && this.payPwd.length === 6) {
    //     this.pay()
    //   }
    }
  }
}
</script>
<style lang="postcss" scoped>
.pwd-input {
  display: flex;
  position: relative;
  justify-content: space-between;
  & > div {
    flex: none;
    width: 42px;
    height: 42px;
    border: 1px solid #cecece;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & > input {
    position: absolute;
    width: 100%;
    height: 100%;
    outline: none;
    opacity: 0;
    &:focus ~ div {
      &.active {
        border-color: rgb(82 168 236 / 60%);
        &:before {
          content: "|";
          font-weight: bold;
          animation: buling 1s infinite;
        }
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%),
          0 0 8px rgb(82 168 236 / 60%);
      }
    }
  }

  &.large {
     & > div {
        width: 50px;
        height: 50px;
        font-size: 25px;
     }
  }
}
@keyframes buling {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  51% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
</style>
